'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { AuthPolicyCreatePage, SETTINGS_AUTH_POLICY_PATHS } from '@/features/authentication-policy';
export const Route = createFileRoute('/_staff/settings/authentication/_layout/policies/new/')({
  component: () => <AuthPolicyCreatePage paths={SETTINGS_AUTH_POLICY_PATHS} />
});